import { atom } from 'recoil';
import { AtomKeys } from 'stores/storeKeys';
import { DiagnosisPublishType } from 'types/diagnosisPublishType';
/**
 * コンテンツの状態
 */
export type DiagnosisContentStateType = DiagnosisPublishType;

export const DiagnosisContentState = atom<DiagnosisContentStateType>({
  key: AtomKeys.DIAGNOSIS_CONTENT_STATE,
  default: {
    diagnosis: null,
    company: null,
  },
});
